
const APP_OPTIONS_CONFIG_KEY = "dynamicComponentOptions";

function appCatalog() {
  if (typeof window === "undefined") {
    return {};
  }
  return window.blclient?.data?.dbApps ?? {};
}

function declarationsForApp(appName) {
  const declarations = appCatalog()[appName]?.config?.[APP_OPTIONS_CONFIG_KEY];
  return declarations && typeof declarations === "object" ? declarations : {};
}

function declaredComponentReferenceKeys() {
  const keys = [];
  for (const appName of Object.keys(appCatalog())) {
    for (const [key, declaration] of Object.entries(declarationsForApp(appName))) {
      if (declaration && declaration.componentReference) {
        keys.push(key);
      }
    }
  }
  return keys;
}

module.exports = {
  APP_OPTIONS_CONFIG_KEY,
  declarationsForApp,
  declaredComponentReferenceKeys,
};
